const toggleFilterMobile = () => {
    const surveryFilterToggles = document.querySelectorAll('.js-survey-filter-toggle');
    for (const surveryFilterToggle of surveryFilterToggles) {
        surveryFilterToggle.addEventListener('click', event => {
            event.preventDefault();

            const filter = document.querySelector('.js-survey-filter');
            filter.classList.toggle('is-active');
        });
    }
};

const closeFilterMobile = () => {
    const allQuestions = [
        document.querySelectorAll('.js-main-question'),
        document.querySelectorAll('.js-sub-question'),
    ];

    for (const questions of allQuestions) {
        for (const question of questions) {
            question.addEventListener('click', event => {
                event.preventDefault();

                const filter = document.querySelector('.js-survey-filter');
                filter.classList.remove('is-active');
            });
        }
    }
};

window.addEventListener('DOMContentLoaded', () => {
    const watchMediaBreakpoint = window.matchMedia('(max-width: 992px)');
    if (!watchMediaBreakpoint.matches) {
        return;
    }

    toggleFilterMobile();
    closeFilterMobile();
});
